import { MaskedTextbox } from '@policygenius/mortar';
import { createUseStyles } from 'react-jss';

import getErrorMessage from 'forms/getErrorMessage';

import { MaskedTextFieldProps } from './types';
import styles from '../styles';
import useField from '../useField';

const useStyles = createUseStyles(styles);

const MaskedTextField = ({ id, name, config, ...props }: MaskedTextFieldProps) => {
  const classes = useStyles();
  const { input, meta } = useField<string | number, HTMLInputElement, string>(name, config);

  const _onChange: MaskedTextbox.Props['onChange'] = ({ unmasked }) => input.onChange(unmasked);

  return (
    <div className={classes.fieldContainer}>
      <MaskedTextbox
        {...input}
        {...props}
        defaultValue={String(input.value ?? '')}
        id={id ?? name}
        errorMessage={getErrorMessage(meta)}
        onChange={_onChange}
        type={input.type ?? 'text'}
      />
    </div>
  );
};

export default MaskedTextField;
